'use client'

import { useEffect, useRef } from 'react'

export default function PrivacyPage() {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!containerRef.current) return

    // Create the embed div with name attribute
    const embedDiv = document.createElement('div')
    embedDiv.setAttribute('name', 'termly-embed')
    embedDiv.setAttribute('data-id', '808d5f75-477e-4beb-9fc5-dc3dccb91267')
    containerRef.current.appendChild(embedDiv)

    // Load Termly script if not already loaded
    if (!document.getElementById('termly-jssdk')) {
      const script = document.createElement('script')
      script.id = 'termly-jssdk'
      script.src = 'https://app.termly.io/embed-policy.min.js'
      document.body.appendChild(script)
    }
  }, [])

  return (
    <div data-component-name="PrivacyPage" className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 py-12" ref={containerRef}></div>
    </div>
  )
}
